<template>
	<div class="">
		<!--头部-->
		<Header @toggleLang="toggleLang" @toggleNext="toggleNext"></Header>
		<div class="m-groupOverview">
			<div class="list_count no-padding-top">
				<div class="wow fadeInUp animated">
					<img class="list_img" :src="zidiyiData.group_overview.files" />
				</div>
				<div class="list_info commo_width firstarea" ref="areas">
					<div class="top_posi wow fadeInUp animated">
						<div class="info_tit">
							<span class="pointer css3" @click="goNavList(0,'area0')"
								:class="index==0?'active':'hover_span'">{{lang=='CN' ?'集团简介':'Group profile'}}</span>
							<span class="pointer css3" @click="goNavList(1,'area1')"
								:class="index==1?'active':'hover_span'">{{lang=='CN' ?'创始人介绍':'Introduction to the Founder'}}</span>
							<span class="pointer css3" @click="goNavList(2,'area2')"
								:class="index==2?'active':'hover_span'">{{lang=='CN' ?'组织架构':'Organizational structure'}}</span>
							<span class="pointer css3" @click="goNavList(3,'area3')"
								:class="index==3?'active':'hover_span'">{{lang=='CN' ?'企业文化':'The enterprise culture'}}</span>
							<span class="pointer css3" @click="goNavList(4,'area4')"
								:class="index==4?'active':'hover_span'">{{lang=='CN' ?'荣誉资质':'Honorary certificate'}}</span>
						</div>
					</div>
					<!-- 集团简介 -->
					<div class="div1 introduct css3" ref="area0">
						<div class="introduct_tit wow fadeInUp animated">
							<div class="eng_tit">TRUSEAS</div>
							<div class="jituan_name">{{lang=='CN' ?'佳信海坛控股集团':'Jiaxin Haitan Holding Group'}}</div>
							<div class="jituan_intro">{{lang=='CN' ?'大正至佳 信融天下':'Dazheng to good faith in the world'}}
							</div>
							<div class="fenge_line"></div>
							<div class="jianshao"
								v-html="lang=='CN' ?zidiyiText.aboutus.cn_text:zidiyiText.aboutus.en_text">
							</div>
						</div>
						<div class="introduct_type wow fadeInUp animated">
							<div class="img_div" @click="wl">
								<img class="css3 pointer" src="@/assets/news/wenlv.png" />
							</div>
							<div class="img_div" @click="zb">
								<img class="css3 pointer" src="@/assets/news/ziben.png" />
							</div>
							<div class="img_div" @click="js">
								<img class="css3 pointer" src="@/assets/news/ziben1.png" />
							</div>
						</div>
						<div class="jieshao_img">
							<img class="css3" :src="zidiyiData.building.files" />
						</div>
					</div>
				</div>
				<!-- 创始人介绍 GO -->
				<div class="div2 founder_introduct css3" ref="area1">
					<div class="founder_info commo_width">
						<div class="info_left wow fadeInUp animated">
							<img :src="zidiyiData.founder.files" />
						</div>
						<div class="info_right wow fadeInUp animated">
							<div class="eng_tit">{{lang=='CN' ?'创始人介绍':'Introduction to the Founder'}}</div>
							<div class="jtdsz">
								<span>{{lang=='CN' ?'林正佳':'Zhengjia Lin'}}</span>
								<el-divider direction="vertical"></el-divider>
								<span>第十四届全国人大代表 / 佳信海坛控股集团董事长</span>
							</div>
							<div class="line1"></div>
							<div class="csr_xinxi  wow fadeInUp animated"
								v-html="lang=='CN' ?zidiyiContent.area2.cn_content:zidiyiContent.area2.en_content">
							</div>
						</div>
					</div>
				</div>
				<!-- 组织结构 -->
				<div class="div3 zzjg commo_width css3 wow fadeInUp animated" ref="area2">
					<div class="zzjg_tit">
						<span>组织结构</span>
						<el-divider direction="vertical"></el-divider>
						<span>ORGANIZATIONAL STRUCTURE</span>
					</div>
					<el-image class="zzpic pic img-responsive" :src="zidiyiData.organization.files"></el-image>
				</div>
				<!-- 企业文化 -->
				<div class="div4 css3 qywh wow fadeInUp animated" ref="area3">
					<div class="commo_width">
						<div class="qywh_info">
							<div class="tit_img">
								<img :src="zidiyiData.culture.files" />
							</div>
							<div class="qywh_tit">
								<span>企业文化</span>
								<el-divider direction="vertical"></el-divider>
								<span>ORGANIZATIONAL STRUCTURE</span>
							</div>
							<div class="info_list"
								v-html="lang=='CN' ?zidiyiContent.culture.cn_content:zidiyiContent.culture.en_content">
							</div>
							<div class="list_botton ">
								<div @click="go_list(65)" class="btn_square btn_more pointer">
									<em>查看更多 MOER</em><span></span>
								</div>
							</div>

						</div>
					</div>
				</div>
				<!-- 企业荣誉 -->
				<div class="div5 div5 qyry commo_width wow fadeInUp animated" ref="area4">
					<div class="qyry_tit wow fadeInUp animated">
						<span>荣誉资质</span>
						<el-divider direction="vertical"></el-divider>
						<span>ORGANIZATIONAL STRUCTURE</span>
					</div>
					<div class="qyry_cont">
						<div class="cont">
							<div class="cont_left wow fadeInUp animated">
								<img :src="zidiyiData.honour1.files" />
							</div>
							<div class="cont_right wow fadeInUp animated">
								<div class="swiper-container">
									<swiper :options="swiperOption1" ref="mySwiper" :pagination="{clickable:true}"
										v-if="honourList.length>0">
										<div class="swiper-slide" v-for="(item,index) in honourList" :key="item.title"
											@click.stop="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)">
											<div class="item">
												<div class="txt">{{lang=='CN' ?item.cn_title:item.en_title}}</div>
											</div>
										</div>
									</swiper>
									<!-- 如果需要分页器 -->
									<div class="swiper-pagination1">
									</div>
									<!-- 如果需要导航按钮 -->
									<div class="swiper-button-prev1"></div>
									<div class="swiper-button-next1"></div>
									<!-- 如果需要滚动条 -->
									<div class="swiper-scrollbar1">
									</div>
								</div>


								<!-- 							<ul>
									<li
										v-html="lang=='CN' ?zidiyiContent.honorary.cn_content:zidiyiContent.honorary.en_content">
									</li>
								</ul> -->
								<div class="imgs">
									<div class="hover_img wow fadeInUp animated">
										<img class="css3" :src="zidiyiData.honour2.files" />
									</div>
									<div class="hover_img">
										<img class="css3" :src="zidiyiData.honour3.files" />
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="list_botton ">
						<div @click="go_list(66)" class="btn_square btn_more pointer">
							<em>查看更多 MOER</em><span></span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '@/components/Header'
	import Footer from '@/components/Footer'
	import {
		add_pv,
		get_content_all,
		get_file_all,
		archives_list,
		get_text_all
	} from '@/api/api.js'




	import {
		WOW
	} from 'wowjs'
	export default {
		components: {
			Header,
			Footer
		},
		name: 'group_overview',
		data() {
			return {
				index: 0,
				parent_id: 8,
				list: [], //
				per_page: 9,
				page: 1,
				zidiyiData: {
					group_overview: {
						files: ''
					},
					building: {
						files: ''
					},
					founder: {
						files: ''
					},
					organization: {
						files: ''
					},
					culture: {
						files: ''
					},
					honour1: {
						files: ''
					},
					honour2: {
						files: ''
					},
					honour3: {
						files: ''
					},
				},
				swiperOption1: {
					autoplay: {
						delay: 5000,
						// stopOnLastSlide: false,
						disableOnInteraction: false
					},
					loop: true,
					direction:"vertical", 
					slidesPerView: 6,
					slidesPerGroup:6,
					// 显示分页
					pagination: {
						el: ".swiper-pagination1",
						clickable: true //允许分页点击跳转
					},
					// 设置点击箭头
					navigation: {
						nextEl: ".swiper-button-next1",
						prevEl: ".swiper-button-prev1"
					}
				},
				zidiyiContent: {
					culture: {
						cn_content: '',
						en_content: ''
					},
					area2: {
						cn_content: '',
						en_content: ''
					},
					honorary: {
						cn_content: '',
						en_content: ''
					},
				},
				zidiyiText: {
					aboutus: {
						cn_text: '',
						en_text: ''
					}
				},
				honourList: [], //内容列表
				content: {}, //内容详情
				total: '',
				company_id: 1, //公司ID
				banner: '',
				lang: localStorage.getItem('lang') || 'CN',
				isFixed: false
			}
		},
		created() {
			this.getZidiyiContent() //自定义文本
			this.getZidiyiData() //自定义图片
			this.getZidiyiText()
			this.getHonourList()
			localStorage.setItem('current', 1)
			this.addLocatPath()
			var wow = new WOW({
				boxClass: 'wow',
				animateClass: 'animated',
				offset: 0,
				mobile: true,
				live: true
			});
			wow.init();
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll) // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
		},
		methods: {
			//列表
			getHonourList() {
				let data = {
					channel_id: 66,
					per_page: 7,
					page: 1
				}
				archives_list(data).then(res => {
					if (res.code == 1) {

						this.honourList = res.data.data
						console.log(this.honourList, 999)
						this.categoryBgsIndex = index
						this.fuactive = id
						this.total = res.data.total
					}
				}).catch(err => {});
			},
			go(id) {
				this.$router.push({
					path: `new_detail?id=${id}`
				})
			},
			go_open(url) {
				if (url) {
					window.open(url, "_blank");
				}
			},
			handleScroll() {
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body
					.scrollTop // 滚动条偏移量
				let offsetTop = document.querySelector('.top_posi').offsetTop; // 要滚动到顶部吸附的元素的偏移量
				this.isFixed = scrollTop > offsetTop ? true : false; // 如果滚动到顶部了，this.isFixed就为true
				if (this.isFixed) {
					$(".top_posi").addClass("fixednav");
				} else {
					$(".top_posi").removeClass("fixednav");
				}

			},
			toggleLang(str) {
				localStorage.setItem('lang', str)
				this.lang = str
			},
			toggleNext(index) {
				this.goNavList(index)
			},
			zb() {
				this.$router.push({
					name: 'Coreplate',
					query: {
						parent_id: 9,
						curr: 1
					}
				})
			},
			wl() {
				this.$router.push({
					name: 'Coreplate',
					query: {
						parent_id: 9,
						curr: 0
					}
				})
			},
			js() {
				this.$router.push({
					name: 'Coreplate',
					query: {
						parent_id: 9,
						curr: 2
					}
				})
			},
			addLocatPath() {
				let data = {
					directions: '集团概况',
					path: window.location.href
				}
				add_pv(data).then((res) => {}).catch(err => {});
			},
			// 获取自定富文本
			getZidiyiContent() {
				let data = {}
				get_content_all(data).then((res) => {
					this.zidiyiContent = res.data
				}).catch(err => {});
			},
			// 获取自定义图片
			getZidiyiData() {
				let data = {}
				get_file_all(data).then((res) => {
					this.zidiyiData = res.data
				}).catch(err => {});
			},
			// 获取自定义文本
			getZidiyiText() {
				let data = {}
				get_text_all(data).then((res) => {
					this.zidiyiText = res.data
				}).catch(err => {});
			},

			//页面锚点定位
			goNavList(val, area) {
				this.index = val
				let height = 0;
				// 获取元素在页面中的位置
				height = this.$refs[area].getBoundingClientRect().top
				switch (val) {
					case 0:
						this.$el.querySelector(".div1").scrollIntoView({
							block: "start",
							behavior: "smooth"
						});
						break;
					case 1:
						this.$el.querySelector(".div2").scrollIntoView({
							block: "start",
							behavior: "smooth"
						});
						break;
					case 2:
						this.$el.querySelector(".div3").scrollIntoView({
							block: "start",
							behavior: "smooth"
						});
						break;
					case 3:
						this.$el.querySelector(".div4").scrollIntoView({
							block: "start",
							behavior: "smooth"
						});
						break;
					case 4:
						this.$el.querySelector(".div5").scrollIntoView({
							block: "start",
							behavior: "smooth"
						});
						break;
					default:
						break;
				}
			},

			scrollTo(y, duration) {
				/* y:目标纵坐标，duration:时间(单位ms毫秒) */
				var scrollTop = document.body.scrollTop /* 页面当前滚动距离 */
				var distance = y - scrollTop /* 结果若大于0,说明目标在下方；若小于0,说明目标在上方 */
				var scrollCount = duration / 10 /* 10毫秒滚动一次,计算滚动次数 */
				var everyDistance = parseInt(distance / scrollCount) /* 滚动距离除以滚动次数计算每次滚动距离 */
				for (
					var index = 1; index <= scrollCount; index++ /* 循环设置scrollBy事件,在duration之内,完成滚动效果 */
				) {
					setTimeout(function() {
						window.scrollBy(0, everyDistance)
					}, 10 * index)
				}
				let deviation = y - scrollCount * everyDistance
				window.scrollBy(0, deviation)
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				this.page = val
				console.log(`当前页: ${val}`);
			},
			go_list(id) {
				this.$router.push({
					path: `list`,
					query: {
						parent_id: 7,
						id: id
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.animated {
		visibility: visible !important;
	}

	.css3 {
		transition: all 0.3s ease 0s;
		-webkit-transition: all 0.3s ease 0s;
		-moz-transition: all 0.3s ease 0s;
		-o-transition: all 0.3s ease 0s;
	}

	h1,
	h2 {
		font-weight: normal;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}

	a {
		color: #42b983;
	}

	.main .contact-way {
		margin-top: 0 !important;
	}

	.firstarea {
		margin-top: 60px !important;
	}

	.m-groupOverview {
		background: #fff;
	}

	.m-groupOverview .list_count {
		padding: 30px 30px 100px 30px;
	}

	.m-groupOverview .commo_width {
		margin: 0px auto;
		padding-top: 100px;
		max-width: 1400px;
	}

	.m-groupOverview .list_count .list_img {
		width: 100%;
	}

	.m-groupOverview .info_tit {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		max-width: 1400px;
	}

	.m-groupOverview .info_tit span {
		background: #ffffff;
		width: 260px;
		height: 60px;
		line-height: 60px;
		text-align: center;
		color: #666;
		font-size: 14px;
		display: block;
		border: 2px solid #EBF3F5;
		margin-right: 25px;
	}

	.m-groupOverview .info_tit span:last-child {
		margin-right: 0 !important;
	}

	.m-groupOverview .hover_span {
		cursor: pointer;
	}

	.m-groupOverview .info_tit .active {
		border: 2px solid #006170;
		/* box-shadow: 0px 3px 10px #eaeaea; */
		color: #006170;
		font-weight: bold;
	}

	.m-groupOverview .introduct_tit {
		padding: 60px;
	}

	.m-groupOverview .eng_tit {
		font-size: 12px;
		color: #257683;
		margin-bottom: 30px;
	}

	.m-groupOverview .jituan_name {
		font-size: 30px;
		color: #000;
		font-weight: bold;
		margin-bottom: 20px;
	}

	.m-groupOverview .jituan_intro {
		font-size: 30px;
		color: #333333;
		font-weight: normal;
	}

	.m-groupOverview .fenge_line {
		width: 80px;
		height: 3px;
		background: #295266;
		margin: 30px 0;
	}

	.m-groupOverview .jianshao {
		font-size: 15px;
		color: #000;
		line-height: 30px;
	}

	.m-groupOverview .introduct_type {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.m-groupOverview .introduct_type .img_div {
		width: 420px;
		overflow: hidden;
	}

	.m-groupOverview .introduct_type img {
		width: 100%;
		margin-right: 45px;
	}

	.m-groupOverview .introduct_type img:hover {
		transform: scale(1.2)
	}

	.m-groupOverview .introduct_type img:last-child {
		margin-right: 0 !important;
	}

	.m-groupOverview .jieshao_img {
		overflow: hidden;
		width: 100%;
		height: 300px;
		margin: 50px 0 150px;
	}

	.m-groupOverview .jieshao_img img {
		width: 100%;
		height: 300px;
	}

	.m-groupOverview .jieshao_img img:hover {
		transform: scale(1.2)
	}

	.m-groupOverview .founder_introduct {
		background: #f0f4f5;
		height: 917px;
	}

	.m-groupOverview .founder_introduct .info_left img {
		margin-top: -70px;
		width: 720px;
	}

	.m-groupOverview .founder_info {
		display: flex;
	}

	.m-groupOverview .founder_info .info_right {
		padding: 30px 0px 0 50px;
	}

	.m-groupOverview .founder_info .csr_xinxi {
		width: 610px;
		color: #000;
		font-size: 18px;
		line-height: 36px;
		letter-spacing: 1.2px;
	}

	.m-groupOverview .jtdsz span:first-child {
		font-size: 18px;
		font-weight: bold;
		color: #000;
	}

	.m-groupOverview .jtdsz span:last-child {
		font-size: 12px;
		color: #999;
	}

	.m-groupOverview .line1 {
		width: 80px;
		height: 3px;
		background: #295266;
		margin: 20px 0;
	}

	.m-groupOverview .el-divider {
		background-color: #666 !important;
	}

	.m-groupOverview .zzjg_block1 {
		width: 300px;
		height: 60px;
		line-height: 60px;
		color: #fff;
		font-size: 18px;
		background: #006170;
		margin: 30PX auto 0;
		text-align: center;
		border-radius: 5px;
	}

	.m-groupOverview .zzjg_tit span:first-child {
		font-size: 30px;
		font-weight: bold;
		color: #000;
	}

	.m-groupOverview .zzjg_tit span:last-child {
		font-size: 14px;
		color: #999;
	}

	.m-groupOverview .zzjg_block2 {
		width: 3px;
		height: 30px;
		background: #006170;
		margin: 0 auto;
	}

	.m-groupOverview .zzjg_block3 {
		width: 939px;
		border-top: 3px solid #006170;
		margin-left: 130px;
	}

	.m-groupOverview .zzjg_block10 {
		display: flex;
		width: 1200px;
		margin: 0 auto;
	}

	.m-groupOverview .zzjg_block10 span:nth-child(1) {
		display: block;
		width: 133px;
		border-right: 3px solid #006170;
		height: 30px;
	}

	.m-groupOverview .zzjg_block10 span:nth-child(2) {
		display: block;
		width: 309px;
		border-right: 3px solid #006170;
		height: 30px;
	}

	.m-groupOverview .zzjg_block10 span:nth-child(3) {
		display: block;
		width: 312px;
		border-right: 3px solid #006170;
		height: 30px;
	}

	.m-groupOverview .zzjg_block10 span:nth-child(4) {
		display: block;
		width: 315px;
		border-right: 3px solid #006170;
		height: 30px;
	}

	.m-groupOverview .zzjg_block4 {
		display: flex;
	}

	.m-groupOverview .zzjg_block4 span {
		display: block;
		width: 270px;
		height: 60px;
		line-height: 60px;
		text-align: center;
		color: #fff;
		background: #006170;
		border-radius: 5px;
		margin-right: 40px;
	}

	.m-groupOverview .zzjg_block4 span:last-child {
		margin-right: 0 !important;
	}

	.m-groupOverview .zzjg_block5 {
		display: flex;
	}

	.m-groupOverview .zzjg_block5 div {
		width: 267px;
		height: 30px;
		text-align: center;
		margin-right: 42px;
	}

	.m-groupOverview .zzjg_block5 div span {
		display: block;
		width: 3px;
		height: 30px;
		background: #006170;
		margin: 0 auto;
	}

	.m-groupOverview .zzjg_block6 {
		display: flex;
	}

	.m-groupOverview .zzjg_block6 div {
		width: 267px;
		height: 60px;
		line-height: 60px;
		text-align: center;
		margin-right: 44px;
		border: 1px solid #006170;
		border-radius: 5px;
		background: #f0f4f5;
		color: #006170;
	}

	.m-groupOverview .zzjg_block7 {
		display: flex;
	}

	.m-groupOverview .zzjg_block7 div:nth-child(1) {
		width: 267px;
		height: 30px;
		text-align: center;
		margin-right: 40px;
		margin-left: 309px;
	}

	.m-groupOverview .zzjg_block7 div:nth-child(2) {
		width: 267px;
		height: 30px;
		text-align: center;
		margin-right: 40px;
	}

	.m-groupOverview .zzjg_block7 div span {
		display: block;
		width: 3px;
		height: 30px;
		background: #006170;
		margin: 0 auto;
	}

	.m-groupOverview .zzjg_block8 {
		display: flex;
	}

	.m-groupOverview .zzjg_block8 div {
		width: 267px;
		height: 60px;
		line-height: 60px;
		text-align: center;
		margin-right: 45px;
		border: 1px solid #006170;
		border-radius: 5px;
		background: #f0f4f5;
		color: #006170;
	}

	.m-groupOverview .zzjg_block8 div:nth-child(1) {
		margin-left: 309px;
	}

	.zzpic {
		padding-bottom: 50px;
	}

	.m-groupOverview .qywh_tit {
		margin-top: 60px;
	}

	.m-groupOverview .qywh_tit span:first-child {
		font-size: 30px;
		font-weight: bold;
		color: #000;
	}

	.m-groupOverview .qywh_tit span:last-child {
		font-size: 14px;
		color: #999;
	}

	.m-groupOverview .qywh {
		background: #f0f4f5;
		margin-top: 100px;
		height: 1460px;

	}

	.m-groupOverview .qywh .commo_width {
		position: relative;
	}

	.m-groupOverview .qywh .qywh_info {
		position: absolute;
		top: -50px;
		left: 0;
	}

	.m-groupOverview .qywh .tit_img img {
		width: 100%;
		height: 260px;
	}


	.m-groupOverview .qyry_tit span:first-child {
		font-size: 30px;
		font-weight: bold;
		color: #000;
	}

	.m-groupOverview .qyry_tit span:last-child {
		font-size: 14px;
		color: #999;
	}

	.m-groupOverview .qyry_cont {
		width: 100%;
		height: 680px;
	}

	.m-groupOverview .cont {
		width: 100%;
		height: 400px;
		background: #006170;
		margin-top: 50px;
		display: flex;
		position: relative;
	}

	.m-groupOverview .qyry_cont .cont_left img {
		margin: 61px 37px 0 61px;
		width: 360px;
	}

	.m-groupOverview .cont_right {
		width: 890px;
		margin: 70px 50px 0 0;
		color: #fff;
		.imgs {
			display: flex;
			position: absolute;
			bottom: -210px;
			
			 .hover_img {
				overflow: hidden;
				width: 421px;
				height: 260px;
				margin-right: 37px;
				img {
					width: 100%;
					height: 100%;
					&:hover {
						transform: scale(1.2)
					}
				}
			}
		}
		.swiper-container{
			width: 100%;
			height: 240px;
			overflow: hidden;
			.item{
				width: 100%;
				cursor: pointer;
				height: 40px;
				line-height: 40px;
				font-size: 16px;
				white-space: nowrap;
				text-overflow: ellipsis;
				overflow: hidden;
				&:hover{
					opacity: .8;
				}
			}
		}
		
	}

	.fixednav {
		position: fixed;
		top: 10px;
		left: 12.5%px;
		max-width: 1400px;
		z-index: 20;
		width: 100%;
		background: none;
	}

	@media screen and (max-width: 1400px) {
		.m-groupOverview .commo_width {
			width: 100%;
		}

		.m-groupOverview .info_tit {
			width: 100%;
		}
	}
</style>

<style>
	.m-groupOverview .cont_right ul li p {
		margin: 0;
		position: relative;
		padding-left: 20px;
	}

	.cont_right ul li p span {
		position: relative;
	}


	.m-groupOverview .cont_right ul li span::after {
		content: '';
		width: 2px;
		background: #ffffff;
		display: block;
		height: 2px;
		position: absolute;
		top: 9px;
		left: -20px;
	}


	.info_list dl {
		margin: 55px 0 55px 0;
		width: 100%;
		overflow: hidden;
	}

	.info_list dt {
		width: 240px;
		height: 30px;
		overflow: hidden;
		font-weight: normal;
		color: #000000;
		float: left;
	}

	.info_list dt span {
		width: 110px;
		height: 30px;
		float: left;
		font-size: 24px;
	}

	.info_list dt em {
		width: 110px;
		height: 30px;
		float: left;
		display: block;
		background: url(../assets/culture.png) center no-repeat;
	}

	.list_botton {
		display: flex;
		justify-content: center;
	}

	.list_botton .btn_square {
		height: 26px;
		width: 120px;
		color: #FFFFFF;
		background-color: #006170;

	}

	.list_botton .btn_more {
		width: 280px;
		height: 70px;
		font-size: 18px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 15px;
	}

	.list_botton .btn_more span {
		display: table-row-group;
		padding-left: 15px;
		vertical-align: middle;
	}

	.info_list dd {
		width: calc(100% - 240px);
		display: block;
		float: left;
		color: #323333 !important;
		font-size: 18px;
	}
</style>
